<style>
  .remove-cost-btn {
    color: #E78383;
    background: transparent;
    border: none;
    padding: 0;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
  }
  .remove-cost-btn:hover,
  .remove-cost-btn:focus {
    color: #C46F6F; /* darker on hover */
  }
</style>
<div style="display: flex; flex-direction: row; justify-content: space-between">
  <div
    class="rfq-create-form"
    [ngClass]="{
      'full-width-container1': !showDetailSection,
      'half-width-container1': showDetailSection
    }"
    style="display: flex; flex-direction: column; overflow-x: hidden"
  >
    <div class="rfq-create-form-title">
      <!-- <div style="display: flex;flex-direction:row;justify-content: space-between;">
            <div id="createquotation" style="flex:1">
                Create Quotation
            </div>
            <div style="display: flex; flex-wrap: wrap; gap: 12px; padding: 10px; justify-content: flex-end;flex:3;background-color:white;">
                <button class="right-button" (click)="rfqActions('download')">Download file</button>
                <button class="right-button" (click)="rfqActions('decline')"
                [disabled]="headerData?.docStatus == 'Declined'"
                [ngClass]="{'disabled-button': headerData?.docStatus == 'Declined'}">Decline</button>
                <button class="right-button" (click)="rfqActions('acknowledge')"
                [disabled]="headerData?.docStatus == 'Acknowledged'"
                [ngClass]="{'disabled-button': headerData?.docStatus == 'Acknowledged'}">Acknowledge</button>
                <button class="right-button" (click)="toggleShowHeaderDetails({checked: !showDetailSection})">
                    {{ showDetailSection ? 'Hide RFQ Details' : 'Show RFQ Details' }}
                </button>
            </div>
          </div> -->

      <div
        style="
          width: 100%;
          display: flex;
          flex-wrap: wrap;
          gap: 12px;
          padding: 10px;
          justify-content: flex-end;
          background-color: white;
        "
      >
        <!-- <button class="right-button" (click)="rfqActions('download')">Download file</button>
                <button class="right-button" (click)="rfqActions('decline')"
                [disabled]="headerData?.docStatus == 'Declined'"
                [ngClass]="{'disabled-button': headerData?.docStatus == 'Declined'}">Decline</button>
                <button class="right-button" (click)="rfqActions('acknowledge')"
                [disabled]="headerData?.docStatus == 'Acknowledged'"
                [ngClass]="{'disabled-button': headerData?.docStatus == 'Acknowledged'}">Acknowledge</button> -->
        <!-- <button mat-button color="primary"
                    style="font-size:18px; padding-left: 32px; padding-right: 32px; padding-top: 24px; padding-bottom: 24px; background-color: #f99c30!important;"
                    (click)="save()"><mat-icon>save</mat-icon> Next</button> -->
        <!-- <button mat-button color="primary"
                    style="font-size:18px; padding-left: 32px; padding-right: 32px; padding-top: 24px; padding-bottom: 24px; background-color: #f99c30!important;"
                    (click)="closeLineItems()">Close<mat-icon>navigate_next</mat-icon></button> -->
        <button
          mat-button
          color="primary"
          style="
            font-size: 18px;
            padding-left: 32px;
            padding-right: 32px;
            padding-top: 24px;
            padding-bottom: 24px;
            background-color: #f99c30 !important;
          "
          (click)="close(true)"
        >
          Close<mat-icon>navigate_next</mat-icon>
        </button>

        <button
          class="right-button"
          (click)="toggleShowHeaderDetails({ checked: !showDetailSection })"
        >
          {{ showDetailSection ? "Hide RFQ Details" : "Show RFQ Details" }}
        </button>
      </div>

      <div
        style="
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          margin-top: 10px;
          margin-bottom: 5px;
        "
      >
        <div id="createquotation">Create Quotation</div>
        <!-- <div>
                <button mat-button color="primary"
                    style="font-size:18px; padding-left: 32px; padding-right: 32px; padding-top: 24px; padding-bottom: 24px; background-color: #f99c30!important;"
                    (click)="save()"><mat-icon>save</mat-icon> Next</button>
                <button mat-button color="primary"
                    style="font-size:18px; padding-left: 32px; padding-right: 32px; padding-top: 24px; padding-bottom: 24px;"
                    (click)="closeLineItems()">Close<mat-icon>navigate_next</mat-icon></button>
              </div> -->
      </div>
    </div>

    <div
      class="col-xl-10 col-lg-9 col-9 p-0 card-body-fixheight z-index-4"
      style="width: 100%"
    >
      <mat-card class="p-0" style="margin: 0 0.5rem">
        <mat-card-content class="ship-fscoll hgt ship-pr-sec">
          <nav mat-tab-nav-bar class="tagGroup">
            <a
              mat-tab-link
              *ngFor="let tabItem of tabs; let idx = index"
              [class.active-link]="currentTab === tabItem.route"
              class="teb_icon"
              (click)="selectMatTabLink(tabItem)"
            >
              <span id="navstepstext">{{ tabItem.label }}</span>
            </a>
          </nav>

          <div class="mat-tab-body-content pos-relative">
            <div>
              <div
                style="
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                "
              >
                <div>
                  <form [formGroup]="secondFormGroup">
                    <div
                      class="form-item-row"
                      style=""
                    >
                      <div
                        style="
                          display: flex;
                          flex-direction: column;
                          width: 100%;
                          height: 100%;
                        "
                      >
                        <label>Quote Currency</label>
                        <input
                          *ngIf="headerData?.currencyId?.currencyCode"
                          type="text"
                          [value]="headerData.currencyId.currencyCode + ' - ' + (headerData.currencyId.currencyName || '')"
                          readonly
                          style="background-color: #f0f0f0; padding: 8px; border: 1px solid #ccc; border-radius: 4px; color: #333; cursor: not-allowed;"
                        />
                        <input
                          *ngIf="!headerData?.currencyId?.currencyCode"
                          type="text"
                          value="Loading..."
                          readonly
                          style="background-color: #f9f9f9; padding: 8px; border: 1px solid #e0e0e0; border-radius: 4px; color: #bbb; cursor: not-allowed; font-size: 11px; font-style: italic;"
                        />
                        <div *ngIf="headerData?.currencyId?.currencyCode" style="color: #1976d2; font-size: 11px; margin-top: 6px;">
                          Buyer has requested quotes in {{ headerData.currencyId.currencyCode }}. All prices must be entered in this currency.
                        </div>
                      </div>
                    </div>
                  </form>
                </div>

                <div
                  style="
                    display: flex;
                    justify-content: flex-end;
                    padding-top: 28px;
                  "
                >
                  <div class="wrap-description-toggle">
                    <mat-slide-toggle (change)="toggleWrapDescription($event)"
                      >Wrap Description</mat-slide-toggle
                    >
                  </div>
                  <div class="dropdown-container">
                    <button
                      mat-fab
                      class="green-button"
                      [matMenuTriggerFor]="columnsMenu"
                      matTooltip="Show more columns"
                    >
                      <mat-icon>add</mat-icon>
                    </button>
                    <mat-menu #columnsMenu="matMenu">
                      <button
                        mat-menu-item
                        *ngFor="let col of dynamicColumns"
                        (click)="showColumn(col)"
                      >
                        <mat-checkbox [checked]="col.visible">{{
                          col.name
                        }}</mat-checkbox>
                      </button>
                    </mat-menu>
                  </div>
                </div>
              </div>
              <div
                style="
                  display: flex;
                  flex-direction: column;
                  overflow-x: auto;
                  width: 100%;
                "
              >
                <!-- <div style="overflow-x: scroll;"> -->
                <!-- <div style="width: 100%;"> -->
                <!-- <div>

                                      <form [formGroup]="lineItemtableForm">
                                          <table mat-table [dataSource]="dataSource" class="mat-elevation-z8"
                                              formArrayName="rows">

                                              
                                              <ng-container matColumnDef="checkbox">
                                                  <th mat-header-cell *matHeaderCellDef>
                                                      
                                                  </th>
                                                  <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
                                                      
                                                  </td>
                                              </ng-container>

                                            

                                              
                                              <ng-container matColumnDef="position">
                                                  <th mat-header-cell *matHeaderCellDef> S.No. </th>
                                                  <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
                                                      <input matInput formControlName='position' [disabled]="true"
                                                          readonly style="width: 40px;" />
                                                  </td>
                                              </ng-container>

                                              
                                              <ng-container matColumnDef="partNumber">
                                                  <th mat-header-cell *matHeaderCellDef> Part Number </th>
                                                  <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
                                                      <input matInput [formControlName]="'partNumber'"
                                                          [attr.disabled]="true" readonly />
                                                  </td>
                                              </ng-container>

                                              
                                              <ng-container matColumnDef="supplierPartNumber">
                                                  <th mat-header-cell *matHeaderCellDef>Supplier Part Number </th>
                                                  <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
                                                      <input matInput [formControlName]="'supplierPartNumber'" [readonly]="isDecline(i)"
                                                          />
                                                  </td>
                                              </ng-container>


                                              
                                              <ng-container matColumnDef="itemDescription">
                                                  <th mat-header-cell *matHeaderCellDef> Item Description </th>
                                                  <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
                                                      <textarea matInput [formControlName]="'itemDescription'"
                                                          [disabled]="true" readonly
                                                          [ngClass]="{ 'expanded-input': isWrapDescription }"
                                                          [rows]="isWrapDescription ? 4 : 1"
                                                          matTooltipClass="mat-tooltip-custom"></textarea>
                                                  </td>
                                              </ng-container>

                                              
                                              <ng-container matColumnDef="buyerComment">
                                                  <th mat-header-cell *matHeaderCellDef> Buyer Comment </th>
                                                  <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
                                                      <textarea matInput [formControlName]="'buyerComment'"
                                                          [disabled]="true" readonly
                                                          [ngClass]="{ 'expanded-input': isWrapDescription }"
                                                          [rows]="isWrapDescription ? 4 : 1"></textarea>
                                                  </td>
                                              </ng-container>

                                              
                                              <ng-container matColumnDef="supplierComment">
                                                  <th mat-header-cell *matHeaderCellDef> Supplier Comment </th>
                                                  <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
                                                      <textarea matInput [formControlName]="'supplierComment'"
                                                          [ngClass]="{ 'expanded-input': isWrapDescription }"
                                                          [rows]="isWrapDescription ? 4 : 1" [readonly]="isDecline(i)"></textarea>
                                                  </td>
                                              </ng-container>


                                              
                                              <ng-container matColumnDef="customsCode">
                                                  <th mat-header-cell *matHeaderCellDef> Customs Code </th>
                                                  <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
                                                      <input matInput [formControlName]="'customsCode'"
                                                          style="width: 100px;" [readonly]="isDecline(i)"/>
                                                  </td>
                                              </ng-container>

                                              
                                              <ng-container matColumnDef="attachments">
                                                  <th mat-header-cell *matHeaderCellDef> Attachments </th>
                                                  <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
                                                    <button mat-icon-button (click)="toggleSidebar(true,'attachment',i)" [disabled]="isDecline(i)">
                                                      <mat-icon>add_circle</mat-icon>
                                                    </button>
                                                  </td>
                                              </ng-container>


                                              
                                              <ng-container matColumnDef="quantity">
                                                  <th mat-header-cell *matHeaderCellDef style="text-align: center;"> Quantity </th>
                                                  <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
                                                      <input matInput [formControlName]="'quantity'"
                                                          [disabled]="true" readonly
                                                          onkeypress="return event.charCode >= 48 && event.charCode <= 57" />
                                                  </td>
                                              </ng-container>

                                              
                                              <ng-container matColumnDef="uom">
                                                  <th mat-header-cell *matHeaderCellDef style="text-align: center;"> UOM </th>
                                                  <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
                                                      <input matInput [formControlName]="'uom'" readonly
                                                          style="width: 100px;" />
                                                  </td>
                                              </ng-container>

                                              
                                              <ng-container matColumnDef="supplierQuantity">
                                                  <th mat-header-cell *matHeaderCellDef style="text-align: center;">Supplier Quantity </th>
                                                  <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
                                                      <input matInput [formControlName]="'supplierQuantity'"
                                                          (blur)="calculateRowValues(i)"
                                                          onkeypress="return event.charCode >= 48 && event.charCode <= 57" 
                                                          [readonly]="isDecline(i)"/>
                                                  </td>
                                              </ng-container>
                                              
                                              
                                              <ng-container matColumnDef="supplierUom">
                                                  <th mat-header-cell *matHeaderCellDef style="text-align: center;"> Supplier UOM </th>
                                                  <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
                                                      <input matInput [formControlName]="'supplierUom'" 
                                                          pattern="[A-Za-z\s]*" style="width: 100px;" [readonly]="isDecline(i)" (keypress)="allowOnlyLetters($event)"/>
                                                  </td>
                                              </ng-container>

                                              
                                              <ng-container matColumnDef="unitCost">
                                                  <th mat-header-cell *matHeaderCellDef> Unit Cost </th>
                                                  <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
                                                      <input type="number" matInput [formControlName]="'unitCost'"
                                                          (blur)="calculateRowValues(i)" [disabled]="true" step="any"
                                                          [readonly]="isDecline(i)" />
                                                  </td>
                                              </ng-container>

                                              
                                              <ng-container matColumnDef="discount">
                                                  <th mat-header-cell *matHeaderCellDef> Discount </th>
                                                  <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
                                                      <input type="number" matInput [formControlName]="'discount'"
                                                          (blur)="calculateRowValues(i)" step="any"  
                                                          [readonly]="isDecline(i)"/>
                                                  </td>
                                              </ng-container>

                                              
                                              
                                              <ng-container matColumnDef="totalCost">
                                                  <th mat-header-cell *matHeaderCellDef> Total Cost </th>
                                                  <td mat-cell *matCellDef="let row;let i = index" [formGroupName]="i">
                                                      <input type="number" matInput [formControlName]="'totalCost'"
                                                          [disabled]="true" step="any" readonly 
                                                          />
                                                  </td>
                                              </ng-container>
                            
                                              
                                              <ng-container matColumnDef="leadTime">
                                                  <th mat-header-cell *matHeaderCellDef> Lead Time </th>
                                                  <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
                                                      <input matInput [formControlName]="'leadTime'"
                                                          style="width: 100px;" [readonly]="isDecline(i)"/>
                                                  </td>
                                              </ng-container>
                                              <ng-container matColumnDef="delete">
                                                <th mat-header-cell *matHeaderCellDef> Actions </th>
                                                <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
                                                  <button *ngIf="!isDecline(i)" mat-icon-button (click)="toggleSidebar(true,'decline', i)">
                                                    <mat-icon>delete</mat-icon>
                                                  </button>

                                          

                                                </td>
                                            </ng-container>

                                              
                                              <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                                              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                                          </table>

                                      </form>

                                  </div> -->
                <!-- </div> -->
                <form [formGroup]="lineItemtableForm">
                  <!-- <ngx-datatable
                                  #table
                                  class="material expandable"
                                  [rows]="dataSource"
                                  [headerHeight]="50"
                                  [footerHeight]="50"
                                  [rowHeight]="'auto'"
                                  [columnMode]="'standard'"
                                  [scrollbarH]="true"
                                  [externalPaging]="false"
                                  [externalSorting]="false"
                                  [limit]="10"
                                  style="width: max-content;">
                                
                                  <ngx-datatable-column name="S.No.">
                                    <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                      <input matInput [formControl]="lineItemtableForm.get('rows')['controls'][rowIndex].get('position')" readonly style="width: 40px;" />
                                    </ng-template>
                                  </ngx-datatable-column>

                                  <ngx-datatable-column name="Part Number">
                                    <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                      <input matInput [formControl]="lineItemtableForm.get('rows')['controls'][rowIndex].get('partNumber')" readonly />
                                    </ng-template>
                                  </ngx-datatable-column>

                                  <ngx-datatable-column name="Supplier Part Number">
                                    <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                      <input matInput [formControl]="lineItemtableForm.get('rows')['controls'][rowIndex].get('supplierPartNumber')" [readonly]="isDecline(rowIndex)" />
                                    </ng-template>
                                  </ngx-datatable-column>

                                  <ngx-datatable-column name="Item Description">
                                    <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                      <textarea matInput [formControl]="lineItemtableForm.get('rows')['controls'][rowIndex].get('itemDescription')"
                                        [disabled]="true" readonly
                                        [ngClass]="{ 'expanded-input': isWrapDescription }"
                                        [rows]="isWrapDescription ? 4 : 1"
                                        matTooltipClass="mat-tooltip-custom"></textarea>
                                    </ng-template>
                                  </ngx-datatable-column>

                                  <ngx-datatable-column name="Buyer Comment">
                                    <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                      <textarea matInput [formControl]="lineItemtableForm.get('rows')['controls'][rowIndex].get('buyerComment')"
                                        [disabled]="true" readonly
                                        [ngClass]="{ 'expanded-input': isWrapDescription }"
                                        [rows]="isWrapDescription ? 4 : 1"></textarea>
                                    </ng-template>
                                  </ngx-datatable-column>

                                  <ngx-datatable-column name="Supplier Comment">
                                    <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                      <textarea matInput [formControl]="lineItemtableForm.get('rows')['controls'][rowIndex].get('supplierComment')"
                                        [ngClass]="{ 'expanded-input': isWrapDescription }"
                                        [rows]="isWrapDescription ? 4 : 1"
                                        [readonly]="isDecline(rowIndex)"></textarea>
                                    </ng-template>
                                  </ngx-datatable-column>
                                  
                                  <ngx-datatable-column name="Customs Code">
                                    <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                      <input matInput [formControl]="lineItemtableForm.get('rows')['controls'][rowIndex].get('customsCode')" [readonly]="isDecline(rowIndex)" />
                                    </ng-template>
                                  </ngx-datatable-column>

                                  <ngx-datatable-column name="Requested Quantity">
                                    <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                      <input matInput [formControl]="lineItemtableForm.get('rows')['controls'][rowIndex].get('quantity')"
                                        [disabled]="true" readonly onkeypress="return event.charCode >= 48 && event.charCode <= 57" />
                                    </ng-template>
                                  </ngx-datatable-column>

                                  <ngx-datatable-column name="Requested UOM">
                                    <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                      <input matInput [formControl]="lineItemtableForm.get('rows')['controls'][rowIndex].get('uom')" readonly style="width: 100px;" />
                                    </ng-template>
                                  </ngx-datatable-column>

                                  <ngx-datatable-column name="Unit Cost">
                                    <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                      <input type="number" matInput [formControl]="lineItemtableForm.get('rows')['controls'][rowIndex].get('unitCost')"
                                        (blur)="calculateRowValues(rowIndex)" [disabled]="true" step="any" [readonly]="isDecline(rowIndex)" />
                                    </ng-template>
                                  </ngx-datatable-column>

                                  <ngx-datatable-column name="Discount">
                                    <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                      <input type="number" matInput [formControl]="lineItemtableForm.get('rows')['controls'][rowIndex].get('discount')"
                                        (blur)="calculateRowValues(rowIndex)" step="any" [readonly]="isDecline(rowIndex)" />
                                    </ng-template>
                                  </ngx-datatable-column>

                                  <ngx-datatable-column name="Total Cost">
                                    <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                      <input type="number" matInput [formControl]="lineItemtableForm.get('rows')['controls'][rowIndex].get('totalCost')"
                                        [disabled]="true" step="any" readonly />
                                    </ng-template>
                                  </ngx-datatable-column>

                                  <ngx-datatable-column name="Lead Time">
                                    <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                      <input matInput [formControl]="lineItemtableForm.get('rows')['controls'][rowIndex].get('leadTime')" style="width: 100px;" [readonly]="isDecline(rowIndex)" />
                                    </ng-template>
                                  </ngx-datatable-column>

                                  <ngx-datatable-column name="Supplier UOM">
                                    <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                      <input matInput pattern="[A-Za-z\\s]*" style="width: 100px;" [formControl]="lineItemtableForm.get('rows')['controls'][rowIndex].get('supplierUom')" [readonly]="isDecline(rowIndex)" (keypress)="allowOnlyLetters($event)" />
                                    </ng-template>
                                  </ngx-datatable-column>

                                  <ngx-datatable-column name="Supplier Quantity">
                                    <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                      <input matInput [formControl]="lineItemtableForm.get('rows')['controls'][rowIndex].get('supplierQuantity')"
                                        (blur)="calculateRowValues(rowIndex)"
                                        onkeypress="return event.charCode >= 48 && event.charCode <= 57" [readonly]="isDecline(rowIndex)" />
                                    </ng-template>
                                  </ngx-datatable-column>

                                  <ngx-datatable-column name="Attachments">
                                    <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                      <button mat-icon-button (click)="toggleSidebar(true, 'attachment', rowIndex)" [disabled]="isDecline(rowIndex)">
                                        <mat-icon>add_circle</mat-icon>
                                      </button>
                                    </ng-template>
                                  </ngx-datatable-column>

                                  <ngx-datatable-column name="Delete">
                                    <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                      <button *ngIf="!isDecline(rowIndex)" mat-icon-button (click)="toggleSidebar(true, 'decline', rowIndex)">
                                        <mat-icon>delete</mat-icon>
                                      </button>
                                    </ng-template>
                                  </ngx-datatable-column>

                                </ngx-datatable> -->

                  <ngx-datatable
                    #table
                    class="material expandable"
                    [rows]="dataSource"
                    [headerHeight]="50"
                    [footerHeight]="50"
                    [rowHeight]="'auto'"
                    [columnMode]="'force'"
                    [scrollbarH]="true"
                    [externalPaging]="false"
                    [externalSorting]="false"
                    [limit]="10"
                  >
                    <ngx-datatable-column name="S.No." [width]="100">
                      <ng-template
                        let-rowIndex="rowIndex"
                        ngx-datatable-cell-template
                      >
                        <input
                          matInput
                          [formControl]="
                            lineItemtableForm
                              .get('rows')
                              ['controls'][rowIndex].get('position')
                          "
                          readonly
                          style="width: 40px"
                          [matTooltip]="getDeclineReason(rowIndex)"
                          [matTooltipDisabled]="!isDecline(rowIndex)"
                        />
                      </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column name="Part Number">
                      <ng-template
                        let-rowIndex="rowIndex"
                        ngx-datatable-cell-template
                      >
                        <ng-container *ngIf="isNew(rowIndex)">
                          <app-paginated-autocomplete-manual
                            [displayWithFunc]="
                              filterFieldSupplierProductNameDisplayFn
                            "
                            [dataSrc]="boundGetSupplierProductAutoComplete"
                            [controlName]="'addedLineItempartNumber'"
                            [control]="getPartNumberControl(rowIndex)"
                            [placeholder]="'Select Part NUmber'"
                            [label]="'Part Number'"
                            (autoCompleteOptionSelected)="
                              onPartNumberSelected($event, rowIndex)
                            "
                          >
                          </app-paginated-autocomplete-manual>

                          <!-- <ng-container *ngIf="getPartNumberControl(rowIndex); else fallbackControl">
                                        <app-paginated-autocomplete-manual
                                            [displayWithFunc]="filterFieldSupplierProductNameDisplayFn"
                                            [dataSrc]="boundGetSupplierProductAutoComplete"
                                            [controlName]="'addedLineItempartNumber'"
                                            [control]="getPartNumberControl(rowIndex)"
                                            [placeholder]="'Select Part Number'"
                                            [label]="'Part Number'"
                                            (autoCompleteOptionSelected)="onPartNumberSelected($event, rowIndex)">
                                        </app-paginated-autocomplete-manual>
                                        </ng-container>
                                         
                                        <ng-template #fallbackControl>
                                        <app-paginated-autocomplete-manual
                                            [displayWithFunc]="filterFieldSupplierProductNameDisplayFn"
                                            [dataSrc]="boundGetSupplierProductAutoComplete"
                                            [controlName]="'addedLineItempartNumber'"
                                            [control]="getPartNumberControl(rowIndex)" 
                                            [placeholder]="'Select Part Number'"
                                            [label]="'Part Number'"
                                            (autoCompleteOptionSelected)="onPartNumberSelected($event, rowIndex)">
                                        </app-paginated-autocomplete-manual>
                                        </ng-template>

                                        </ng-container> -->
                        </ng-container>

                        <ng-container *ngIf="!isNew(rowIndex)">
                          <input
                            matInput
                            [formControl]="
                              lineItemtableForm
                                .get('rows')
                                ['controls'][rowIndex].get('partNumber')
                            "
                            readonly
                            [matTooltip]="getDeclineReason(rowIndex)"
                            [matTooltipDisabled]="!isDecline(rowIndex)"
                          />
                        </ng-container>
                      </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column name="Supplier Part Number">
                      <ng-template
                        let-rowIndex="rowIndex"
                        ngx-datatable-cell-template
                      >
                        <input
                          matInput
                          [formControl]="
                            lineItemtableForm
                              .get('rows')
                              ['controls'][rowIndex].get('supplierPartNumber')
                          "
                          [readonly]="isDecline(rowIndex)"
                          [matTooltip]="getDeclineReason(rowIndex)"
                          [matTooltipDisabled]="!isDecline(rowIndex)"
                        />
                        <!-- <input
                                        matInput
                                        type="text"
                                        inputmode="numeric"
                                        pattern="[0-9]*"
                                        maxlength="30"
                                        [formControl]="lineItemtableForm.get('rows')['controls'][rowIndex].get('supplierPartNumber')"
                                        [readonly]="isDecline(rowIndex)"
                                        [matTooltip]="getDeclineReason(rowIndex)"
                                        [matTooltipDisabled]="!isDecline(rowIndex)"
                                        (keypress)="($event.charCode >= 48 && $event.charCode <= 57) ? true : $event.preventDefault()"
                                      /> -->
                      </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column name="Item Description">
                      <ng-template
                        let-rowIndex="rowIndex"
                        ngx-datatable-cell-template
                      >
                        <textarea
                          matInput
                          [formControl]="
                            lineItemtableForm
                              .get('rows')
                              ['controls'][rowIndex].get('itemDescription')
                          "
                          [disabled]="true"
                          readonly
                          [ngClass]="{ 'expanded-input': isWrapDescription }"
                          [rows]="isWrapDescription ? 4 : 1"
                          matTooltipClass="mat-tooltip-custom"
                          [matTooltip]="getDeclineReason(rowIndex)"
                          [matTooltipDisabled]="!isDecline(rowIndex)"
                        ></textarea>
                      </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column name="Buyer Comment">
                      <ng-template
                        let-rowIndex="rowIndex"
                        ngx-datatable-cell-template
                      >
                        <textarea
                          matInput
                          [formControl]="
                            lineItemtableForm
                              .get('rows')
                              ['controls'][rowIndex].get('buyerComment')
                          "
                          [disabled]="true"
                          readonly
                          [ngClass]="{ 'expanded-input': isWrapDescription }"
                          [rows]="isWrapDescription ? 4 : 1"
                          [matTooltip]="getDeclineReason(rowIndex)"
                          [matTooltipDisabled]="!isDecline(rowIndex)"
                        ></textarea>
                      </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column name="Supplier Comment">
                      <ng-template
                        let-rowIndex="rowIndex"
                        ngx-datatable-cell-template
                      >
                        <textarea
                          matInput
                          [formControl]="
                            lineItemtableForm
                              .get('rows')
                              ['controls'][rowIndex].get('supplierComment')
                          "
                          [ngClass]="{ 'expanded-input': isWrapDescription }"
                          [rows]="isWrapDescription ? 4 : 1"
                          [readonly]="isDecline(rowIndex)"
                          [matTooltip]="getDeclineReason(rowIndex)"
                          [matTooltipDisabled]="!isDecline(rowIndex)"
                        ></textarea>
                      </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column name="Customs Code">
                      <ng-template
                        let-rowIndex="rowIndex"
                        ngx-datatable-cell-template
                      >
                        <input
                          matInput
                          [formControl]="
                            lineItemtableForm
                              .get('rows')
                              ['controls'][rowIndex].get('customsCode')
                          "
                          [readonly]="isDecline(rowIndex)"
                          [matTooltip]="getDeclineReason(rowIndex)"
                          [matTooltipDisabled]="!isDecline(rowIndex)"
                        />
                      </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column name="Requested Quantity">
                      <ng-template
                        let-rowIndex="rowIndex"
                        ngx-datatable-cell-template
                      >
                        <input
                          matInput
                          [formControl]="
                            lineItemtableForm
                              .get('rows')
                              ['controls'][rowIndex].get('quantity')
                          "
                          [disabled]="true"
                          readonly
                          onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                          [matTooltip]="getDeclineReason(rowIndex)"
                          [matTooltipDisabled]="!isDecline(rowIndex)"
                        />
                      </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column name="Quoted Quantity">
                      <ng-template
                        let-rowIndex="rowIndex"
                        ngx-datatable-cell-template
                      >
                        <input
                          matInput
                          [formControl]="
                            lineItemtableForm
                              .get('rows')
                              ['controls'][rowIndex].get('supplierQuantity')
                          "
                          (blur)="calculateRowValues(rowIndex)"
                          onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                          [readonly]="isDecline(rowIndex)"
                          [matTooltip]="getDeclineReason(rowIndex)"
                          [matTooltipDisabled]="!isDecline(rowIndex)"
                        />
                      </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column name="Requested UOM">
                      <ng-template
                        let-rowIndex="rowIndex"
                        ngx-datatable-cell-template
                      >
                        <input
                          matInput
                          [formControl]="
                            lineItemtableForm
                              .get('rows')
                              ['controls'][rowIndex].get('uom')
                          "
                          readonly
                          style="width: 100px"
                          [matTooltip]="getDeclineReason(rowIndex)"
                          [matTooltipDisabled]="!isDecline(rowIndex)"
                        />
                      </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column name="Quoted UOM">
                      <ng-template
                        let-rowIndex="rowIndex"
                        ngx-datatable-cell-template
                      >
                        <input
                          matInput
                          pattern="[A-Za-z\\s]*"
                          style="width: 100px"
                          [formControl]="
                            lineItemtableForm
                              .get('rows')
                              ['controls'][rowIndex].get('supplierUom')
                          "
                          [readonly]="isDecline(rowIndex)"
                          (keypress)="allowOnlyLetters($event)"
                          [matTooltip]="getDeclineReason(rowIndex)"
                          [matTooltipDisabled]="!isDecline(rowIndex)"
                        />
                      </ng-template>
                    </ngx-datatable-column>

                    <!-- <ngx-datatable-column name="'Quoted Price">
                                    <ng-template ngx-datatable-header-template let-column="column" style="padding: 0px;">
                                      Unit Cost 
                                      <span class="required-star">*</span>
                                      <mat-slide-toggle 
                                        (change)="getColumn('requestedUnitCost') ? showToggleColumns(getColumn('requestedUnitCost')) : null" 
                                        [checked]="getColumn('requestedUnitCost')?.visible" 
                                        class="ml-2">
                                      </mat-slide-toggle>
                                      <button mat-icon-button [matTooltip]="'Currency conversion is powered by ExchangeRate-API and locked at entry.'">
                                        <mat-icon>info</mat-icon>
                                      </button>
                                    </ng-template>
                                    <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                      
                                      <input type="number" matInput [formControl]="lineItemtableForm.get('rows')['controls'][rowIndex].get('unitCost')"
                                        (blur)="calculateRowValues(rowIndex)" [disabled]="true" step="any" [readonly]="isDecline(rowIndex)" 
                                        [matTooltip]="getDeclineReason(rowIndex)" [matTooltipDisabled]="!isDecline(rowIndex)"/>
                                    </ng-template>
                                  </ngx-datatable-column> -->

                                  <ngx-datatable-column name="Quoted Price" [sortable]="true" [width]="220">
                                    <ng-template ngx-datatable-header-template let-column="column">
                                      <div class="datatable-header-flex">
                                        <span class="datatable-header-text">
                                          Quoted Price <span class="required-star">*</span>
                                        </span>
                                  
                                        <mat-slide-toggle
                                          (change)="getColumn('requestedUnitCost') ? showToggleColumns(getColumn('requestedUnitCost')) : null" 
                                          [checked]="getColumn('requestedUnitCost')?.visible"
                                          class="ml-2">
                                        </mat-slide-toggle>
                                  
                                        <button mat-icon-button style="padding: 0px;"
                                          [matTooltip]="'Currency conversion is powered by ExchangeRate-API and locked at entry.'">
                                          <mat-icon>info</mat-icon>
                                        </button>
                                  
                                        <!-- This renders the built-in sort icon -->
                                        <span class="datatable-sort-icon" [class.active]="column.sort?.dir">
                                          <i [ngClass]="{
                                            'fa fa-caret-up': column.sort?.dir === 'asc',
                                            'fa fa-caret-down': column.sort?.dir === 'desc'
                                          }"></i>
                                        </span>
                                      </div>
                                    </ng-template>
                                  
                                    <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                      
                                      <input type="number" matInput 
                                        [formControl]="lineItemtableForm.get('rows')['controls'][rowIndex].get('unitCost')"
                                        (blur)="calculateRowValues(rowIndex)" 
                                        [disabled]="true" step="any"  min="0" 
                                        [readonly]="isDecline(rowIndex)" 
                                        [matTooltip]="getDeclineReason(rowIndex)" 
                                        [matTooltipDisabled]="!isDecline(rowIndex)" />
                                    </ng-template>
                                  </ngx-datatable-column>
                                  
                                  <ngx-datatable-column type='button' *ngIf="getColumn('requestedUnitCost')?.visible" name="Requested Price">
                                    <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                      {{headerData?.currencyId?.currencyCode}} {{ lineItemtableForm.get('rows')['controls'][rowIndex].get('requestedUnitCost').value | number: '1.2-2' }}
                                    </ng-template>
                                  </ngx-datatable-column>

                    <ngx-datatable-column name="Discount">
                      <ng-template
                        let-rowIndex="rowIndex"
                        ngx-datatable-cell-template
                      >
                        <input
                          type="number"
                          matInput
                          [formControl]="
                            lineItemtableForm
                              .get('rows')
                              ['controls'][rowIndex].get('discount')
                          "
                          (blur)="calculateRowValues(rowIndex)"
                          step="any" min="0" 
                          [readonly]="isDecline(rowIndex)"
                          [matTooltip]="getDeclineReason(rowIndex)"
                          [matTooltipDisabled]="!isDecline(rowIndex)"
                        />
                      </ng-template>
                    </ngx-datatable-column>

                                  <ngx-datatable-column name="Total Quoted Price" [sortable]="true" [width]="220">
                                    <ng-template ngx-datatable-header-template let-column="column">
                                      <div class="datatable-header-flex">
                                        <span class="datatable-header-text">Total Quoted Price</span>

                                        <mat-slide-toggle
                                          (change)="getColumn('requestedTotalCost') ? showToggleColumns(getColumn('requestedTotalCost')) : null" 
                                          [checked]="getColumn('requestedTotalCost')?.visible"
                                          class="ml-2">
                                        </mat-slide-toggle>
                                  
                                        <button mat-icon-button style="padding: 0px;"
                                          [matTooltip]="'Currency conversion is powered by ExchangeRate-API and locked at entry.'">
                                          <mat-icon>info</mat-icon>
                                        </button>
                                  
                                        <!-- Sorting arrow (aligned to right) -->
                                        <span class="datatable-sort-icon" [class.active]="column.sort?.dir">
                                          <i [ngClass]="{
                                            'fa fa-caret-up': column.sort?.dir === 'asc',
                                            'fa fa-caret-down': column.sort?.dir === 'desc'
                                          }"></i>
                                        </span>
                                      </div>
                                    </ng-template>
                                  
                                    <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                      <input type="number" matInput 
                                        [formControl]="lineItemtableForm.get('rows')['controls'][rowIndex].get('totalCost')"
                                        [disabled]="true" step="any" readonly
                                        [matTooltip]="getDeclineReason(rowIndex)" 
                                        [matTooltipDisabled]="!isDecline(rowIndex)" />
                                    </ng-template>
                                  </ngx-datatable-column>
                                  

                                  <ngx-datatable-column type='button' *ngIf="getColumn('requestedTotalCost')?.visible" name="Total Requested Price">
                                    <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                        {{headerData?.currencyId?.currencyCode}} {{ lineItemtableForm.get('rows')['controls'][rowIndex].get('requestedTotalCost').value | number: '1.2-2' }}
                                    
                                    </ng-template>
                                  </ngx-datatable-column>

                    <ngx-datatable-column name="Lead Time">
                      <ng-template
                        ngx-datatable-header-template
                        let-column="column"
                      >
                        Lead Time <span class="required-star">*</span>
                      </ng-template>
                      <ng-template
                        let-rowIndex="rowIndex"
                        ngx-datatable-cell-template
                      >
                        <input
                          type="number"
                          matInput
                          [formControl]="
                            lineItemtableForm
                              .get('rows')
                              ['controls'][rowIndex].get('leadTime')
                          "
                          style="width: 100px"   min="0" 
                          [readonly]="isDecline(rowIndex)"
                          [matTooltip]="getDeclineReason(rowIndex)"
                          [matTooltipDisabled]="!isDecline(rowIndex)"
                        />
                      </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column
                      type="button"
                      *ngIf="getColumn('attachments')?.visible"
                      name="Attachments"
                    >
                      <ng-template
                        let-rowIndex="rowIndex"
                        ngx-datatable-cell-template
                      >
                        <button
                          mat-icon-button
                          (click)="toggleSidebar(true, 'attachment', rowIndex)"
                          [disabled]="isDecline(rowIndex)"
                        >
                          <mat-icon>add_circle</mat-icon>
                        </button>
                      </ng-template>
                    </ngx-datatable-column>

                    <!-- <ngx-datatable-column name="Supplier UOM">
                                    <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                      <input matInput pattern="[A-Za-z\\s]*" style="width: 100px;" [formControl]="lineItemtableForm.get('rows')['controls'][rowIndex].get('supplierUom')" [readonly]="isDecline(rowIndex)" (keypress)="allowOnlyLetters($event)" />
                                    </ng-template>
                                  </ngx-datatable-column>

                                  <ngx-datatable-column  name="Supplier Quantity">
                                    <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                      <input matInput [formControl]="lineItemtableForm.get('rows')['controls'][rowIndex].get('supplierQuantity')"
                                        (blur)="calculateRowValues(rowIndex)"
                                        onkeypress="return event.charCode >= 48 && event.charCode <= 57" [readonly]="isDecline(rowIndex)" />
                                    </ng-template>
                                  </ngx-datatable-column>

                                  <ngx-datatable-column type='button'  name="Attachments">
                                    <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                      <button mat-icon-button (click)="toggleSidebar(true, 'attachment', rowIndex)" [disabled]="isDecline(rowIndex)">
                                        <mat-icon>add_circle</mat-icon>
                                      </button>
                                    </ng-template>
                                  </ngx-datatable-column> -->

                    <!-- <ngx-datatable-column name="Delete">
                                    <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                      <button *ngIf="!isDecline(rowIndex)" mat-icon-button  (click)="toggleSidebar(true, 'decline', rowIndex)">
                                        <mat-icon>delete</mat-icon>
                                      </button>
                                      <button *ngIf="!isDecline(rowIndex)" mat-icon-button color="warn"  (click)="toggleSidebar(true, 'decline', rowIndex)">
                                        <mat-icon>highlight_off</mat-icon>
                                      </button>
                                    </ng-template>
                                  </ngx-datatable-column> -->
                    <ngx-datatable-column name="" [width]="80">
                      <ng-template
                        let-rowIndex="rowIndex"
                        ngx-datatable-cell-template
                      >
                        <button
                          type="button"
                          *ngIf="!isDecline(rowIndex)"
                          mat-icon-button
                          class="delete-icon-button"
                          (click)="toggleSidebar(true, 'decline', rowIndex)"
                        >
                          <mat-icon>close</mat-icon>
                        </button>

                        <button
                          type="button"
                          *ngIf="isDecline(rowIndex)"
                          mat-icon-button
                          class="delete-icon-button"
                          (click)="restoreLineitem(rowIndex)"
                        >
                          <mat-icon>restore</mat-icon>
                        </button>
                      </ng-template>
                    </ngx-datatable-column>
                  </ngx-datatable>
                </form>

                <button
                  mat-raised-button
                  color="primary"
                  (click)="addNewLineItem()"
                  style="width: 10%"
                >
                  Add New Row
                </button>
              </div>

              <div
                [ngClass]="{
                  secondformcontainerfull: !showDetailSection,
                  secondformcontainerhalf: showDetailSection
                }"
                style="margin: 30px; float: right"
              >
                <form [formGroup]="secondFormGroup">
                  <div class="floating-card-container" [class.is-open]="isTotalsCardOpen">
                    <div class="floating-card">
                      <div
                        style="
                          display: flex;
                          justify-content: space-between;
                          align-items: center;
                          padding: 10px 20px;
                          font-weight: bold;
                        "
                      >
                        <span
                          ><b
                            >Total
                            <span
                              *ngIf="
                                secondFormGroup.get('supplierCurrency')?.value
                                  ?.currencyCode !== null
                              "
                            >
                              ({{
                                secondFormGroup.get("supplierCurrency")?.value
                                  .currencyCode
                              }})
                            </span></b
                          ></span
                        >
                        <span>{{
                          secondFormGroup.get("quoteLineItemTotal")?.value ||
                            0.0
                        }}</span>
                      </div>
                      <div class="card-body mx-4">
                        <!-- your full card HTML content here -->
                        <!-- Ensure you REMOVE duplicate outer <div class="card"> and just keep inner content here -->
                        <!-- For brevity not pasting again, your code fits here directly -->
                        <div class="container">
                          <!-- <p class="my-3 mx-5" style="font-size: 30px; justify-content: center; display: flex; font-weight: bold;">Total</p> -->
                          <div class="row">
                            <!-- <ul class="list-unstyled">

                                            <li class="text-black mt-1" style="color: white !important;"> <b>Date: </b>{{currentdate | date:'dd/MM/yyyy' }}</li>
                                          </ul> -->
                            <hr />
                            <div class="col-xl-10">
                              <p>Line Item list Price Sub Total</p>
                            </div>
                            <div class="col-xl-2">
                              <p class="float-end">
                                <input
                                  type="number"
                                  matInput
                                  [formControlName]="
                                    'quoteLineItemListPriceSubtotal'
                                  "
                                  [disabled]="true"
                                  step="any"
                                  readonly
                                />
                              </p>
                            </div>
                            <div class="col-xl-10">
                              <p>Line Item Discount</p>
                            </div>
                            <div class="col-xl-2">
                              <p class="float-end">
                                <input
                                  type="number"
                                  matInput
                                  [formControlName]="'quoteLineItemDiscount'"
                                  [disabled]="true"
                                  step="any"
                                  readonly
                                />
                              </p>
                            </div>
                            <div class="col-xl-10">
                              <p><b>Line Item Sub Total</b></p>
                            </div>
                            <div class="col-xl-2">
                              <p class="float-end">
                                <input
                                  type="number"
                                  matInput
                                  [formControlName]="'quoteLineItemSubtotal'"
                                  [disabled]="true"
                                  step="any"
                                  readonly
                                />
                              </p>
                            </div>
                            <hr />
                          </div>
                          <div class="row">
                            <div class="col-xl-10">
                              <p><b>General Discount ({{ secondFormGroup.get('quoteLineItemGeneralDiscountValue')?.value }}%)</b></p>
                              <!-- <small class="form-error-msg gd-amount" style="color: blue" *ngIf="isEditingGeneralDiscount">
                                <div style="padding: 2px">
                                  Calculated Discount Amount:
                                  {{ generalDiscountAmount | number: '1.2-2' }}
                                  {{ headerData?.currencyId?.currencyCode }}
                                </div>
                              </small> -->
                            </div>
                            <div class="col-xl-2">
                              <p class="float-end" style="display: flex; gap: 6px; align-items: center; justify-content: flex-end;">
                                <!-- <select
                                  formControlName="quoteLineItemGeneralDiscountType"
                                  [disabled]="true"
                                  readonly
                                  style="width: 100%; margin-bottom: 10px"
                                >
                                  <option value="percentage">Percentage</option>
                                  <option value="amount"> value</option>
                                </select> -->
                                <button mat-icon-button class="gd-edit-btn" type="button" (click)="onEditGeneralDiscountClick()" matTooltip="Edit General Discount">
                                  <mat-icon>edit</mat-icon>
                                </button>
                                <ng-container *ngIf="isEditingGeneralDiscount; else gdAmountInput1">
                                  <input
                                    type="number"
                                    matInput
                                    [formControlName]="'quoteLineItemGeneralDiscountValue'"
                                    step="any"
                                    #generalDiscountInput
                                    (blur)="onGeneralDiscountBlur()"
                                  />
                                </ng-container>
                                <ng-template #gdAmountInput1>
                                  <input
                                    type="number"
                                    matInput
                                    [value]="generalDiscountAmount"
                                    readonly
                                  />
                                </ng-template>
                              </p>
                            </div>
                            <hr />
                          </div>

                                        <div class="row">
                                          <div class="col-xl-8">
                                            <p><b>Applicable Tax Profile</b>
                                              
                                              <span 
                                                class="add-tax-link"
                                                (click)="toggleTaxSidebar()"
                                                style="margin-left: 8px; color: black; cursor: pointer; font-size: 16px; font-weight: 600;">
                                                +
                                              </span>
                                            </p>
                                          </div>
                                          <div class="col-xl-4">
                                            <div class="float-end" style="display: flex; gap: 10px; align-items: center;">
                                              <mat-select 
                                                  formControlName="quoteLineItemApplicableTaxProfile" 
                                                  (selectionChange)="onTaxProfileChange($event)"
                                                  (openedChange)="isTotalsCardOpen = $event"
                                                  [disableOptionCentering]="true"
                                                  panelClass="tax-profile-panel"
                                                  style="width: 70px; margin-bottom: 10px;padding-left:10px;background-color: white;"
                                                  
                                                >
                                                  <mat-select-trigger>
                                                    {{ secondFormGroup?.get('quoteLineItemTaxType')?.value }}
                                                  </mat-select-trigger>
                                                  <mat-option *ngFor="let item of taxStatusData" [value]="item.taxId" class="plain-select">
                                                    {{ item.nameOfTaxProfile }} - {{ item.country?.name }} - {{ item.taxType }} ({{item.regionName}}) - {{ item.taxNumber }} - {{ item.taxPercentage }} %
                                                  </mat-option>
                                                </mat-select>
                                              

                                              <input type="text" matInput [value]="secondFormGroup.get('quoteLineItemTaxAmount')?.value | number : '1.0-4'" readonly style="margin-bottom: 10px" />
                                            </div>
                                          </div>
                                          <hr>
                                        </div>

                          <!-- <div class="row">
                            <div class="col-xl-10">
                              <p><b>Freight</b></p>
                            </div>
                            <div class="col-xl-2">
                              <p class="float-end">
                                <button
                                  mat-icon-button
                                  matTooltipClass="mat-tooltip-custom"
                                  matTooltip="Add Additional Cost"
                                  matTooltipPosition="below"
                                  (click)="toggleSidebar(true, 'cost')"
                                >
                                  <mat-icon>add_circle</mat-icon>
                                </button>
                              </p>
                            </div>
                            <div
                              *ngIf="
                                secondFormGroup.get('quoteLineItemFreight')
                                  ?.value
                              "
                              style="display: flex; flex-direction: column"
                            >
                              <table class="table table-striped">
                                <thead>
                                  <tr>
                                    
                                    <th>Description</th>
                                    
                                    <th>Value</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr
                                    *ngFor="
                                      let item of secondFormGroup.get(
                                        'quoteLineItemFreight'
                                      )?.value
                                    "
                                  >
                                    <td>
                                      {{
                                        item.freightDescription?.trim()?.toLowerCase() === 'freight'
                                          ? item.freightDescription
                                          : ('Other(' + item.freightDescription + ')')
                                      }}
                                    </td>
                                    
                                    <td>{{ item.freightValue }}</td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                            <div
                              style="
                                display: flex;
                                justify-content: flex-end;
                                margin-bottom: 10px;
                              "
                            >
                              <input
                                type="number"
                                matInput
                                [formControlName]="'quoteLineItemFreightTotal'"
                                step="any"
                                (blur)="calculateCostSummary()"
                                readonly
                              />
                            </div>
                            <hr style="border: 1px solid white" />
                          </div> -->
                          
                          <div class="row">
                            <!-- Initially show the Freight label and Add Cost button -->
                            <div *ngIf="!(secondFormGroup.get('quoteLineItemFreight')?.value?.length > 0) && !showAddCostSection" class="col-xl-10">
                              <p><b>Freight</b></p>
                            </div>

                            <div *ngIf="!(secondFormGroup.get('quoteLineItemFreight')?.value?.length > 0) && !showAddCostSection" class="col-xl-2">
                              <p class="float-end">
                                
                                <button
                                  type="button"
                                  style="color:#29128E;background: transparent;border: none;padding: 0; cursor: pointer; white-space: nowrap;"
                                  (click)="addCost()"
                                >
                                  Add Cost
                                </button>
                              </p>
                            </div>

                            <div class="col-xl-12" *ngIf="secondFormGroup.get('quoteLineItemFreight')?.value?.length > 0">
                              <div
                                *ngFor="let item of secondFormGroup.get('quoteLineItemFreight')?.value; let i = index"
                                class="d-flex align-items-center justify-content-between mb-2"
                              >
                                <div class="d-flex align-items-center">
                                  
                                  <label class="fw-bold me-2" style="min-width: 100px;">
                                    {{
                                      item.freightDescription?.trim()?.toLowerCase() === 'freight'
                                        ? item.freightDescription
                                        : ('Other (' + item.freightDescription + ')')
                                    }}
                                  </label>

                                  <button
                                    *ngIf="item.freightDescription?.trim()?.toLowerCase() === 'freight'"
                                    mat-icon-button
                                    matTooltip="Edit Freight"
                                    matTooltipPosition="below"
                                    (click)="toggleSidebar(true, 'freight')"
                                    class="edit-cost-btn me-2"
                                  >
                                    <mat-icon style="color:#4a4a4a">edit</mat-icon>
                                  </button>

                                  <button
                                    *ngIf="item.freightDescription?.trim()?.toLowerCase() !== 'freight'"
                                    class="remove-cost-btn"
                                    (click)="removeAdditionalCost(i)"
                                  >
                                    <mat-icon>delete</mat-icon>
                                  </button>
                                </div>

                                <div class="freight-wrapper">
                                  <!-- <input
                                    type="number"
                                    matInput
                                    [value]="item.freightValue"
                                    step="any"
                                    readonly
                                  /> -->
                                  <!-- <input
                                    type="text"
                                    matInput
                                    [value]="item.freightValue | number : '1.2-2'"
                                    
                                  /> -->
                                  <input
                                    type="number"
                                    matInput
                                    [value]="item.freightValue"
                                    [readonly]="!isFreight"
                                    (blur)="onFreightEditComplete(i, item, $event)"
                                  />
                                  
                                  <!-- <button
                                    *ngIf="item.freightDescription?.trim()?.toLowerCase() === 'freight'"
                                    mat-icon-button
                                    matTooltip="Remove Freight"
                                    matTooltipPosition="below"
                                    (click)="toggleSidebar(true, 'freight')"
                                    class="remove-btn"
                                  >
                                    <span class="freight-icon-circle">
                                      <mat-icon>close</mat-icon>
                                    </span>
                                  </button> -->
                                </div>
                              </div>
                              <button *ngIf="!showAddCostSection" type="button" (click)="addMoreCost()" style="color:#29128E;background: transparent;border: none;padding: 0; cursor: pointer; white-space: nowrap;">Add Cost</button>
                            </div>

                            <!-- Form fields for adding cost after first click -->
                            <div *ngIf="showAddCostSection" style="margin-top: 10px;">
                              <div style="display: flex; align-items: center; gap: 12px;">
                                <!-- Description (Freight, read-only when initiated from Add Cost) -->
                                <div style="flex: 1;">
                                  <input
                                    class="floating-cart-input"
                                    matInput
                                    [(ngModel)]="freightDescription"
                                    [ngModelOptions]="{standalone: true}"
                                    [readonly]="isFreightCost"
                                    placeholder="Cost"
                                  />
                                </div>

                                <!-- Amount -->
                                <div style="flex: 1;">
                                  <input
                                    class="floating-cart-input"
                                    matInput
                                    [(ngModel)]="freightValue"
                                    [ngModelOptions]="{standalone: true}"
                                    type="number"
                                    step="any"
                                    placeholder="Amount"
                                  />
                                </div>

                                <!-- Add Cost button placed after amount field -->
                                <div *ngIf="!isFreightCost">
                                  <button
                                    class="add-cost-btn-inline"
                                    (click)="saveAdditionalCost()"
                                    [disabled]="(freightValue === null || freightValue === undefined || !freightDescription?.trim() || freightDescription === null)"
                                  >
                                    Add Cost
                                  </button>
                                </div>
                              </div>

                              <!-- Cancel link below the input row -->
                              <div style="margin-top: 8px;">
                                <button *ngIf="!isFreightCost" type="button" class="cancel-text-btn" (click)="cancelAddCost()">Cancel</button>
                                <button *ngIf="isFreightCost" type="button" (click)="addMoreCostAtFreight()" style="color:#29128E;background: transparent;border: none;padding: 0; cursor: pointer; white-space: nowrap;">Add Cost</button>
                              </div>
                            </div>

                            <!-- Display the added costs below -->
                            <!-- <div *ngIf="secondFormGroup.get('quoteLineItemFreight')?.value" style="margin-top: 20px;">
                              <table class="table table-striped">
                                <thead>
                                  <tr>
                                    <th>Description</th>
                                    <th>Value</th>
                                    <th>Actions</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr *ngFor="let cost of secondFormGroup.get(
                                        'quoteLineItemFreight'
                                      )?.value; let i = index">
                                
                                    <td>{{ cost.freightDescription }}</td>
                                    <td>{{ cost.freightValue }}</td>
                                    <td>
                                      <button mat-button (click)="removeAdditionalCost(i)">Delete</button>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div> -->

                            <div style="display: flex; justify-content: flex-end; margin-top: 10px;margin-bottom: 10px;">
                              <input type="text" matInput [value]="secondFormGroup.get('quoteLineItemFreightTotal')?.value | number : '1.0-4'" readonly />
                            </div>

                            <hr style="border: 1px solid white" />
                          </div>

                          <div class="row text-black">
                            <div class="col-xl-12">
                              <p
                                class="float-end fw-bold"
                                style="color: white !important"
                              >
                                Total:
                                <input
                                  type="number"
                                  matInput
                                  [formControlName]="'quoteLineItemTotal'"
                                  [disabled]="true"
                                  step="any"
                                  readonly
                                />
                              </p>
                            </div>
                            <hr style="border: 1px solid white" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- <div class="card">
                            <div class="card-body mx-4">
                              <div class="container">
                                <p class="my-3 mx-5" style="font-size: 30px; justify-content: center; display: flex; font-weight: bold;">Total</p>
                                <div class="row">
                                  <ul class="list-unstyled">

                                    <li class="text-black mt-1"> <b>Date: </b>{{currentdate | date:'dd/MM/yyyy' }}</li>
                                  </ul>
                                  <hr>
                                  <div class="col-xl-10">
                                    <p>Line Item list Price Sub Total</p>
                                  </div>
                                  <div class="col-xl-2">
                                    <p class="float-end">
                                      <input type="number" matInput [formControlName]="'quoteLineItemListPriceSubtotal'" [disabled]="true" step="any" readonly />
                                    </p>
                                  </div>
                                  <div class="col-xl-10">
                                    <p>Line Item Discount</p>
                                  </div>
                                  <div class="col-xl-2">
                                    <p class="float-end">
                                      <input type="number" matInput [formControlName]="'quoteLineItemDiscount'" [disabled]="true" step="any" readonly />

                                    </p>
                                  </div>
                                  <div class="col-xl-10">
                                    <p><b>Line Item Sub Total</b></p>
                                  </div>
                                  <div class="col-xl-2">
                                    <p class="float-end">
                                      <input type="number" matInput [formControlName]="'quoteLineItemSubtotal'" [disabled]="true" step="any" readonly />

                                    </p>
                                  </div>
                                  <hr>
                                </div>
                                <div class="row">
                                  <div class="col-xl-10">
                                    <p><b>General Discount</b></p>
                                    <small class="form-error-msg gd-amount" style="color: blue" *ngIf="isEditingGeneralDiscount">
                                      <div style="padding: 2px">
                                        Calculated Discount Amount:
                                        {{ generalDiscountAmount | number: '1.2-2' }}
                                        {{ headerData?.currencyId?.currencyCode }}
                                      </div>
                                    </small>
                                  </div>
                                  <div class="col-xl-2">
                                    <p class="float-end" style="display: flex; gap: 6px; align-items: center; justify-content: flex-end;">
                                      <select formControlName="quoteLineItemGeneralDiscountType" style="width: 100%; margin-bottom: 10px;">
                                        <option value="percentage">Percentage</option>
                                          <option value="amount"> value</option>
                                          
                                        </select>
                                      <button mat-icon-button class="gd-edit-btn" type="button" (click)="onEditGeneralDiscountClick()" matTooltip="Edit General Discount">
                                        <mat-icon>edit</mat-icon>
                                      </button>
                                      <ng-container *ngIf="isEditingGeneralDiscount; else gdAmountInput2">
                                        <input type="number" matInput [formControlName]="'quoteLineItemGeneralDiscountValue'"  step="any" #generalDiscountInput (blur)="onGeneralDiscountBlur()"/>
                                      </ng-container>
                                      <ng-template #gdAmountInput2>
                                        <input type="number" matInput [value]="generalDiscountAmount" readonly [disabled]="true" />
                                      </ng-template>

                                    </p>
                                  </div>
                                  <hr>
                                </div>
                                <div class="row">
                                  <div class="col-xl-10">
                                    <p><b>Freight (In amount)</b></p>
                                  </div>
                                  <div class="col-xl-2">
                                    <p class="float-end">
                                      <button mat-icon-button matTooltipClass="mat-tooltip-custom" matTooltip="Add Additional Cost"
                                                  matTooltipPosition="below" (click)="toggleSidebar(true,'cost')">
                                                      <mat-icon>add_circle</mat-icon>
                                                </button>


                                    </p>
                                    
                                  </div>
                                  <div *ngIf="secondFormGroup.get('quoteLineItemFreight')?.value" style="display: flex; flex-direction: column;">
                                    <table class="table table-striped">
                                      <thead>
                                        <tr>
                                          <th>Freight Description</th>
                                          <th>Freight Type</th>
                                          <th>value</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr *ngFor="let item of secondFormGroup.get('quoteLineItemFreight')?.value" >
                                          <td>
                                            {{
                                              item.freightDescription?.trim()?.toLowerCase() === 'freight'
                                                ? item.freightDescription
                                                : ('Other(' + item.freightDescription + ')')
                                            }}
                                          </td>
                                          <td>{{item.freightType}}</td>
                                          <td>{{item.freightValue}}</td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                  <div style="display:flex;justify-content: flex-end;margin-bottom: 10px">
                                    <input type="text" matInput [value]="secondFormGroup.get('quoteLineItemFreightTotal')?.value | number : '1.0-4'" readonly/>
                                  </div>
                                  <hr style="border: 2px solid black;">
                                </div>
                                <div class="row text-black">
                          
                                  <div class="col-xl-12">
                                    <p class="float-end fw-bold"> Total: 
                                      <input type="number" matInput [formControlName]="'quoteLineItemTotal'" [disabled]="true" step="any" readonly />
                                    </p>
                                  </div>
                                  <hr style="border: 2px solid black;">
                                </div>
                              
                          
                              </div>
                            </div>
                          </div> -->
                </form>
              </div>
            </div>

            <!-- add new decument -->
            <div
              class="sidebar"
              style="overflow: auto"
              *ngIf="showAddDocumentSection"
            >
              <div
                class="sidebar-title"
                style="justify-content: space-between; padding: 15px 15px"
              >
                <div class="sidebar-title-text">Add New Document</div>
                <div
                  style="
                    display: flex;
                    justify-content: right;
                    width: 50%;
                    gap: 10px;
                  "
                >
                  <!-- <span style="color: #f99c30; font-size: 16px; font-weight: 700;">Total Suppliers : {{UniqueSupplier.length}}</span> -->
                  <!-- <span class="pointer header-close-btn" matTooltipClass="mat-tooltip-custom" matTooltip="Close"
                            matTooltipPosition="below" (click)="expandSection(showSuggestedSupplierFullScreen)">
                          </span> -->
                  <span
                    style="float: right"
                    class="pointer header-close-btn"
                    matTooltipClass="mat-tooltip-custom"
                    matTooltip="Close"
                    matTooltipPosition="below"
                    (click)="toggleSidebar(false, 'attachment')"
                  >
                    <mat-icon style="color: white">close</mat-icon>
                  </span>
                </div>
              </div>

              <div class="sidebar-content">
                <mat-form-field class="full-width" color="accent">
                  <mat-label>Document Type</mat-label>
                  <mat-select
                    [(ngModel)]="selectedAttachmentType"
                    (selectionChange)="onAttachmentTypeChange($event)"
                  >
                    <mat-option
                      *ngFor="let item of lineItemAttachmentTypeData"
                      [value]="item.id"
                    >
                      {{ item.documentTypeDescription }}</mat-option
                    >
                  </mat-select>
                </mat-form-field>

                <mat-form-field
                  class="full-width"
                  color="accent"
                  *ngIf="showHazardousDeclaration"
                >
                  <mat-label>Hazardous Declaration</mat-label>
                  <mat-select [(ngModel)]="hazardousDeclaration">
                    <mat-option [value]="1">
                      Contains Hazardous Materials</mat-option
                    >
                    <mat-option [value]="0">
                      Does NotContainHazardousMaterials</mat-option
                    >
                  </mat-select>
                </mat-form-field>

                <ngx-file-drop
                  class="w100 file-drop-zone"
                  dropZoneLabel="Drop files here"
                  (onFileDrop)="onAttachmentChange($event)"
                  (onFileOver)="fileOver($event)"
                  (onFileLeave)="fileLeave($event)"
                  accept=".svg,.SVG,.png,.PNG,.jpeg,.JPEG,.jpg,.JPG,.pdf,.PDF"
                >
                  <ng-template
                    style="display: flex; flex-direction: row"
                    ngx-file-drop-content-tmp
                    let-openFileSelector="openFileSelector"
                  >
                    <div class="drag-file">
                      <mat-icon>cloud_upload</mat-icon>
                      <p>Drag & drop the file here or</p>
                      <div class="" (click)="openFileSelector()">
                        <p style="color: #74c5b5">upload a file</p>
                      </div>
                      <p>*PDF, JPG or PNG</p>
                    </div>
                  </ng-template>
                </ngx-file-drop>

                <div
                  *ngIf="getLineItemAttachment().length > 0"
                  style="display: flex; flex-direction: column"
                >
                  <h3 style="padding-top: 20px">
                    <b>Line Item Attachments</b>
                  </h3>
                  <div
                    class="file-name-box"
                    *ngFor="let file of getLineItemAttachment()"
                  >
                    {{ file.name }}

                    <button
                      mat-icon-button
                      matTooltipClass="mat-tooltip-custom"
                      matTooltip="View"
                      matTooltipPosition="below"
                      (click)="togglePreview(true, 'single', file.dataUrl)"
                    >
                      <mat-icon>visibility</mat-icon>
                    </button>
                  </div>
                </div>

                <div class="button-container">
                  <button
                    type="button"
                    class="save-button"
                    (click)="toggleSidebar(false, 'attachment')"
                  >
                    <mat-icon>save</mat-icon>
                  </button>
                  <button
                    type="button"
                    class="close-button"
                    (click)="toggleSidebar(false, 'attachment')"
                  >
                    <mat-icon>cancel</mat-icon>
                  </button>
                </div>
              </div>
            </div>

            <!-- add cost -->
            <!-- <div class="sidebar" *ngIf="showAddCostSection">
              <div
                class="sidebar-title"
                style="justify-content: space-between; padding: 15px 15px"
              >
                <div class="sidebar-title-text">Additional Cost</div>
                <div
                  style="
                    display: flex;
                    justify-content: right;
                    width: 50%;
                    gap: 10px;
                  "
                >
                 
                  <span
                    style="float: right"
                    class="pointer header-close-btn"
                    matTooltipClass="mat-tooltip-custom"
                    matTooltip="Close"
                    matTooltipPosition="below"
                    (click)="toggleSidebar(false, 'cost')"
                  >
                    <mat-icon style="color: white">close</mat-icon>
                  </span>
                </div>
              </div>

              <div class="sidebar-content">
                <mat-form-field class="full-width" color="accent">
                  <mat-label>Additional Cost Description</mat-label>
                  <input
                    matInput
                    [(ngModel)]="freightDescription"
                    [ngModelOptions]="{standalone: true}"
                    placeholder="Enter the descritpion for the additional cost"
                  />
                </mat-form-field>

               
                <mat-form-field class="full-width" color="accent">
                  <mat-label>Value</mat-label>
                  <input
                    matInput
                    [(ngModel)]="freightValue"
                    [ngModelOptions]="{standalone: true}"
                    placeholder="Enter the value"
                    onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                  />
                </mat-form-field>

                
                <div class="button-container">
                  <button
                    type="button"
                    class="save-button"
                    (click)="saveAdditionalCost()"
                  >
                    <mat-icon>save</mat-icon>
                  </button>
                  <button
                    type="button"
                    class="close-button"
                    (click)="toggleSidebar(false, 'cost')"
                  >
                    <mat-icon>cancel</mat-icon>
                  </button>
                </div>
              </div>
            </div> -->

            <!-- decline -->
            <div
              class="sidebar"
              style="overflow: auto"
              *ngIf="showDeclineSection"
            >
              <div
                class="sidebar-title"
                style="justify-content: space-between; padding: 15px 15px"
              >
                <div class="sidebar-title-text">
                  Decline to quote on line item
                </div>
                <div
                  style="
                    display: flex;
                    justify-content: right;
                    width: 50%;
                    gap: 10px;
                  "
                >
                  <!-- <span style="color: #f99c30; font-size: 16px; font-weight: 700;">Total Suppliers : {{UniqueSupplier.length}}</span> -->
                  <!-- <span class="pointer header-close-btn" matTooltipClass="mat-tooltip-custom" matTooltip="Close"
                            matTooltipPosition="below" (click)="expandSection(showSuggestedSupplierFullScreen)">
                          </span> -->
                  <span
                    style="float: right"
                    class="pointer header-close-btn"
                    matTooltipClass="mat-tooltip-custom"
                    matTooltip="Close"
                    matTooltipPosition="below"
                    (click)="toggleSidebar(false, 'decline')"
                  >
                    <mat-icon style="color: white">close</mat-icon>
                  </span>
                </div>
              </div>

              <div class="sidebar-content">
                <mat-form-field class="full-width" color="accent">
                  <mat-label>Select a reason for declining</mat-label>
                  <mat-select
                    [(ngModel)]="declineReason"
                    (selectionChange)="onDeclineReasonChange($event)"
                  >
                    <mat-option
                      *ngFor="let item of delineReasonData"
                      [value]="item.id"
                    >
                      {{ item.reasonDescription }}</mat-option
                    >
                  </mat-select>
                </mat-form-field>

                <mat-form-field
                  class="full-width"
                  color="accent"
                  *ngIf="showOtherReason"
                >
                  <mat-label>Other Reason</mat-label>
                  <input
                    matInput
                    [(ngModel)]="otherReason"
                    placeholder="Other reason"
                  />
                </mat-form-field>

                <div class="button-container">
                  <button
                    type="button"
                    class="save-button"
                    (click)="declineLineItem()"
                  >
                    <mat-icon>save</mat-icon>
                  </button>
                  <button
                    type="button"
                    class="close-button"
                    (click)="toggleSidebar(false, 'decline')"
                  >
                    <mat-icon>cancel</mat-icon>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>

  <!-- Popup for confirmation -->
  <!-- <div class="namemodal" *ngIf="showConfirmationDialogue">
    <div class="modalContent">
        <div class="p-6 text-center">
            <div class="flex justify-center mb-4">
                <div class="bg-orange-100 rounded-full w-20 h-20 flex items-center justify-center">
                    <mat-icon class="text-orange-600"
                        style="font-size: 40px;  height:100%; width:100%;">warning</mat-icon>
                </div>
            </div>
            <h2 class="text-xl font-bold mb-2">Are you sure?</h2>
            <p class="mb-6">Are you sure you want to leave this page?<br>Any unsaved attachments will be lost if you leave. Please save them or finish the process in another tab</p>
            <div class="flex justify-center gap-4">
                <button mat-raised-button color="primary" (click)="confirm()">Yes</button>
                <button mat-stroked-button (click)="cancel()">Cancel</button>
            </div>
        </div>
  
    </div>
  </div> -->

  <!-- Popup for confirmation -->
  <!-- <div class="namemodal" *ngIf="showCloseDialogue">
        <div class="modalContent">
            <div class="p-6 text-center">
                <div class="flex justify-center mb-4">
                    <div class="bg-orange-100 rounded-full w-20 h-20 flex items-center justify-center">
                        <mat-icon class="text-orange-600"
                            style="font-size: 40px;  height:100%; width:100%;">warning</mat-icon>
                    </div>
                </div>
                <h2 class="text-xl font-bold mb-2">Are you sure?</h2>
                <p class="mb-6">Are you sure you want to save this RFQ as draft?</p>
                <div class="flex justify-center gap-4">
                    <button mat-raised-button color="primary" (click)="save()">Save as draft</button>
                    <button mat-stroked-button (click)="goToRfqCart()">Cancel</button>
                </div>
            </div>
    
        </div>
    </div> -->
  <!-- Popup for confirmation -->
  <div class="namemodal" *ngIf="showCloseDialogue">
    <div class="modalContent">
      <div class="p-6 text-center">
        <div class="flex justify-center mb-4">
          <div
            class="bg-orange-100 rounded-full w-20 h-20 flex items-center justify-center"
          >
            <mat-icon
              class="text-orange-600"
              style="font-size: 40px; height: 100%; width: 100%"
              >warning</mat-icon
            >
          </div>
        </div>
        <!-- <h2 class="text-xl font-bold mb-2">You want to save this as draft?</h2> -->
        <p class="mb-6">You want to save this as draft?</p>
        <div class="flex justify-center gap-4">
          <button
            mat-raised-button
            color="primary"
            (click)="save(true)"
            style="margin-right: 5px"
          >
            YES
          </button>
          <button
            mat-stroked-button
            (click)="cancel()"
            style="margin-left: 5px"
          >
            NO
          </button>
        </div>
      </div>
    </div>
  </div>

  <div
    class="siderfqbar"
    [ngClass]="{
      'full-width-container2': !showDetailSection,
      'half-width-container2': showDetailSection
    }"
    style="margin-right: 10px; overflow: auto"
  >
    <div class="siderfqbar-title">
      <div class="siderfqbar-title-text">RFQ Details</div>
    </div>

    <div class="siderfqbar-content">
      <!-- <div style="display: flex; flex-wrap: wrap; gap: 12px; padding: 10px; justify-content: flex-start;">
                <button class="right-button" (click)="rfqActions('download')">Download file</button>
                <button class="right-button" (click)="rfqActions('decline')"
                [disabled]="headerData?.docStatus == 'Declined'"
                [ngClass]="{'disabled-button': headerData?.docStatus == 'Declined'}">Decline</button>
                <button class="right-button" (click)="rfqActions('acknowledge')"
                [disabled]="headerData?.docStatus == 'Acknowledged'"
                [ngClass]="{'disabled-button': headerData?.docStatus == 'Acknowledged'}">Acknowledge</button>
            </div> -->

      <div class="header-form">
        <span
          style="
            padding-left: 16px;
            padding-top: 16px;
            margin-bottom: 16px;
            font-weight: bold;
            display: flex;
            justify-content: space-between;
            padding-right: 20px;
          "
          >Buyer Company Details
        </span>

        <div>
          <ul class="list-group">
            <li class="list-group-item">
              Buyer Name : {{ headerData?.buyerCompanyName }}
            </li>
            <li class="list-group-item">
              Email Id : {{ headerData?.companyEmailId }}
            </li>
            <li class="list-group-item">
              Phone : {{ headerData?.companyPhoneNumber }}
            </li>
            <li class="list-group-item">Fax : {{ headerData?.companyFax }}</li>
            <li class="list-group-item">
              Address : {{ headerData?.companyAddress }}
            </li>
          </ul>
        </div>
      </div>

      <div class="header-form">
        <span
          style="
            padding-left: 16px;
            padding-top: 16px;
            margin-bottom: 16px;
            font-weight: bold;
            display: flex;
            justify-content: space-between;
            padding-right: 20px;
          "
        >
          Buyer Details
        </span>

        <div>
          <ul class="list-group">
            <li class="list-group-item">Contact : {{ headerData?.contact }}</li>
            <li class="list-group-item">
              Job Title : {{ headerData?.jobTitle }}
            </li>
            <li class="list-group-item">
              Email Id : {{ headerData?.emailId }}
            </li>
            <li class="list-group-item">Phone : {{ headerData?.phone }}</li>
            <li class="list-group-item">Fax : {{ headerData?.fax }}</li>
            <li class="list-group-item">Address : {{ headerData?.address }}</li>
          </ul>
        </div>
      </div>

      <div class="header-form">
        <span
          style="
            padding-left: 16px;
            padding-top: 16px;
            margin-bottom: 16px;
            font-weight: bold;
            display: flex;
            justify-content: space-between;
            padding-right: 20px;
          "
        >
          RFQ Details
        </span>

        <div>
          <ul class="list-group">
            <li class="list-group-item">
              RFQ Ref Number : {{ headerData?.rfqRefNumber }}
            </li>
            <li class="list-group-item">
              RFQ Date : {{ headerData?.rfqDate | date : "dd/MM/yyyy" }}
            </li>
            <li class="list-group-item">
              Quote by Date :
              {{ headerData?.quotedByDate | date : "dd/MM/yyyy" }}
            </li>
            <li class="list-group-item">
              Document Number : {{ headerData?.docNumber }}
            </li>
            <li class="list-group-item">
              Tracking Number : {{ headerData?.trackingNumber }}
            </li>
          </ul>
        </div>
      </div>

      <div class="header-form">
        <span
          style="
            padding-left: 16px;
            padding-top: 16px;
            padding-bottom: 16px;
            margin-bottom: 16px;
            font-weight: bold;
            display: flex;
            justify-content: space-between;
            padding-right: 20px;
          "
        >
          Vessel Details
        </span>

        <div>
          <ul class="list-group">
            <li class="list-group-item">
              Vessel Name : {{ headerData?.vessel?.vesselName }}
            </li>
            <li class="list-group-item">
              Vessel IMO Number : {{ headerData?.vessel?.imoNumber }}
            </li>
            <li class="list-group-item">
              Vessel Type : {{ headerData?.vessel?.typeOfVessel }}
            </li>
            <li class="list-group-item">
              Class : {{ headerData?.vessel?.class }}
            </li>
            <li class="list-group-item">
              Hull Number : {{ headerData?.vessel?.hullNumber }}
            </li>
            <li class="list-group-item">
              Yard Name : {{ headerData?.vessel?.yardName }}
            </li>
            <li class="list-group-item">
              Year Built : {{ headerData?.vessel?.yearBuilt }}
            </li>
          </ul>
        </div>
      </div>

      <div class="header-form">
        <span
          style="
            padding-left: 16px;
            padding-top: 16px;
            padding-bottom: 16px;
            margin-bottom: 16px;
            font-weight: bold;
            display: flex;
            justify-content: space-between;
            padding-right: 20px;
          "
        >
          Port Details
        </span>

        <div>
          <ul class="list-group">
            <li class="list-group-item">
              Port Name : {{ headerData?.portName }}
            </li>
            <li class="list-group-item">
              Port Code : {{ headerData?.portCode }}
            </li>
            <li class="list-group-item">
              Vessel ETA : {{ headerData?.vesselEta | date : "dd/MM/yyyy" }}
            </li>
            <li class="list-group-item">
              Vessel ETD : {{ headerData?.vesselEtd | date : "dd/MM/yyyy" }}
            </li>
            <li class="list-group-item">
              Vessel ETB : {{ headerData?.vesselEtb | date : "dd/MM/yyyy" }}
            </li>
          </ul>
        </div>
      </div>

      <div class="header-form">
        <span
          style="
            padding-left: 16px;
            padding-top: 16px;
            margin-bottom: 16px;
            font-weight: bold;
            display: flex;
            justify-content: space-between;
            padding-right: 20px;
          "
        >
          Port Agent Details
        </span>

        <div>
          <ul class="list-group">
            <li class="list-group-item">
              Port Agency Name : {{ headerData?.portAgentNumber }}
            </li>
            <li class="list-group-item">
              Port Agent Name : {{ headerData?.portAgentNumber }}
            </li>
            <li class="list-group-item">
              Port Agent Phone Number : {{ headerData?.rfqPortAgentphone }}
            </li>
            <li class="list-group-item">
              Port Agent Contact : {{ headerData?.rfqPortAgentContact }}
            </li>
            <li class="list-group-item">
              Port Agent Fax : {{ headerData?.rfqPortAgentfax }}
            </li>
            <li class="list-group-item">
              Port Agent Email Id : {{ headerData?.rfqPortAgentemailId }}
            </li>
            <li class="list-group-item">
              Address : {{ headerData?.rfqPortAgentaddress }}
            </li>
          </ul>
        </div>
      </div>

      <div class="header-form">
        <span
          style="
            padding-left: 16px;
            padding-top: 16px;
            margin-bottom: 16px;
            font-weight: bold;
            display: flex;
            justify-content: space-between;
            padding-right: 20px;
          "
        >
          Freight Forwarder Details
        </span>

        <div>
          <ul class="list-group">
            <li class="list-group-item">
              Freight Forwarder Company Name :
              {{ headerData?.freightForwarderId }}
            </li>
            <li class="list-group-item">PIC : {{ headerData?.rffdPic }}</li>
            <li class="list-group-item">
              Job Title : {{ headerData?.rffdjobTitle }}
            </li>
            <li class="list-group-item">
              Email Id : {{ headerData?.rffdemailId }}
            </li>
            <li class="list-group-item">Phone : {{ headerData?.rffdphone }}</li>
            <li class="list-group-item">Fax : {{ headerData?.rffdfax }}</li>
            <li class="list-group-item">
              Address : {{ headerData?.rffdaddress }}
            </li>
            <li class="list-group-item">
              Packaging : {{ headerData?.packaging }}
            </li>
            <li class="list-group-item">
              Mode of Transport : {{ headerData?.modeOfTransport }}
            </li>
          </ul>
        </div>
      </div>

      <div class="header-form">
        <span
          style="
            padding-left: 16px;
            padding-top: 16px;
            margin-bottom: 16px;
            font-weight: bold;
            display: flex;
            justify-content: space-between;
            padding-right: 20px;
          "
        >
          Delivery Details
        </span>

        <div>
          <ul class="list-group">
            <li class="list-group-item">
              Request Delivery Date :
              {{ headerData?.requestDeliveryDate | date : "dd/MM/yyyy" }}
            </li>
            <li class="list-group-item">
              Lead Time In Delivery : {{ headerData?.leadTimeInDelivery }}
            </li>
            <li class="list-group-item">
              Contact : {{ headerData?.Deliverycontact }}
            </li>
            <li class="list-group-item">
              Email Id : {{ headerData?.Deliveryemail }}
            </li>
            <li class="list-group-item">
              Phone : {{ headerData?.Deliverycontact }}
            </li>
            <li class="list-group-item">Fax : {{ headerData?.Deliveryfax }}</li>
            <li class="list-group-item">
              Delivery Terms And Conditions :
              {{ headerData?.deliveryTermsAndConditions }}
            </li>
            <li class="list-group-item">
              Delivery Address : {{ headerData?.deliveryAddress }}
            </li>
            <li class="list-group-item">Mode of Transport : {{ headerData?.modeOfTransport || 'N/A' }}</li>
          </ul>
        </div>
      </div>

      <div class="header-form">
        <span
          style="
            padding-left: 16px;
            padding-top: 16px;
            margin-bottom: 16px;
            font-weight: bold;
            display: flex;
            justify-content: space-between;
            padding-right: 20px;
          "
        >
          Invoice Address
        </span>

        <div>
          <ul class="list-group">
            <li class="list-group-item">
              Buyer Name : {{ headerData?.buyerCompanyName }}
            </li>
            <li class="list-group-item">Email Id : {{ headerData?.emailId }}</li>
            <li class="list-group-item">
              Phone : {{ headerData?.companyPhoneNumber }}
            </li>
            <li class="list-group-item">Fax : {{ headerData?.fax }}</li>
            <li class="list-group-item">
              Address : {{ headerData?.invoiceAddress }}
            </li>
          </ul>
        </div>
      </div>

      <div class="header-form">
        <!-- <span
          style="
            padding-left: 16px;
            padding-top: 16px;
            margin-bottom: 16px;
            font-weight: bold;
            display: flex;
            justify-content: space-between;
            padding-right: 20px;
          "
        >
          Buyer Payment Terms
        </span>

        <div>
          <p>{{ headerData?.buyerPaymentTerms }}</p>
        </div> -->

        <div class="header-title">Buyer Payment Terms</div>
        <div class="header-content">
          {{ headerData?.buyerPaymentTerms }}
        </div>
      </div>

      <div class="header-form">
        <!-- <span
          style="
            padding-left: 16px;
            padding-top: 16px;
            margin-bottom: 16px;
            font-weight: bold;
            display: flex;
            justify-content: space-between;
            padding-right: 20px;
          "
        >
          Buyer Terms & Conditions
        </span>

        <div>
          <p>{{ headerData?.buyerTermsAndConditions }}</p>
        </div> -->

        <div class="header-title">Buyer Terms & Conditions</div>
        <div class="header-content pre-line">
          {{ headerData?.buyerTermsAndCondition }}
        </div>
      </div>

      <!-- <div class="button-container">
                <button type="submit" class="save-button" (click)="saveVessel()">
                  <mat-icon>save</mat-icon>
                </button>
                <button type="button" class="close-button" (click)="toggleNewVessel(false)">
                  <mat-icon>cancel</mat-icon>
                </button>
              </div> -->
    </div>
  </div>
</div>

<!-- Notification Overlay to Dim the Background -->
<div *ngIf="showNotification" class="notification-overlay"></div>

<!-- Custom Notification for Missing Fields -->
<div
  *ngIf="showNotification"
  class="notification-popup"
  [ngClass]="{
    'error-notification': notificationType === 'error',
    'info-notification': notificationType === 'info',
    show: showNotification,
    hide: !showNotification
  }"
>
  <div class="notification-content">
    <div class="flex justify-center mb-4">
      <div
        class="bg-orange-100 rounded-full w-20 h-20 flex items-center justify-center"
      >
        <mat-icon
          class="text-orange-600"
          style="font-size: 75px; height: 100%; width: 100%"
          >warning</mat-icon
        >
      </div>
    </div>
    <div class="notification-message" [innerHTML]="notificationMessage"></div>
    <button (click)="dismissNotification()" class="btn-ok">OK</button>
  </div>
</div>

<div class="carousel-container" *ngIf="previewSection">
  <div
    class="carousel-close-button"
    style="display: flex; flex-direction: row; gap: 10px"
  >
    <!-- <button class="image-download-button" *ngIf="buyerAttachmentUrl.length>0"   (click)="downloadDocument(buyerAttachmentUrl[currentIndex])">
          <mat-icon style="font-size:20px">download</mat-icon>
  </button> -->

    <button class="image-close-button" (click)="togglePreview(false, '')">
      <mat-icon style="font-size: 20px">cancel</mat-icon>
    </button>
  </div>
  <div class="carousel">
    <button class="carousel-control prev" (click)="prevSlide()">
      &#10094;
    </button>

    <div class="carousel-image-container">
      <div
        class="headerattachmentcarouselimageContainerInner"
        *ngIf="isPdf(previewDocs[currentIndex])"
      >
        <pdf-viewer
          [src]="previewDocs[currentIndex]"
          [render-text]="false"
          [page]="1"
          [show-all]="true"
          [original-size]="false"
          class="content"
        >
        </pdf-viewer>
      </div>
      <div
        class="headerattachmentimage-container-inner"
        *ngIf="!isPdf(previewDocs[currentIndex])"
      >
        <img
          [src]="previewDocs[currentIndex]"
          [alt]="'headerattachment image'"
          class="carousel-image"
        />
      </div>
    </div>

    <button class="carousel-control next" (click)="nextSlide()">
      &#10095;
    </button>
  </div>
</div>

<!-- Tax Profile Sidebar -->
<form [formGroup]="taxForm">
  <div class="tax-profile-sidebar" [class.open]="showTaxSideBar">
    <div class="sidebar-title">
      <div class="sidebar-title-text">
        Add Tax Profile
      </div>
    </div>
    <div class="sidebar-content">

      <mat-form-field appearance="fill">
        <mat-label>Name of Tax Profile</mat-label>
        <input matInput placeholder="Name of Tax Profile" formControlName="nameOfTaxProfile" />
      </mat-form-field>

      <!-- Country Field -->
      <mat-form-field class="full-width" color="accent">
        <mat-label>Country*</mat-label>
        <mat-select
          formControlName="country"
          (selectionChange)="onTaxCountrySelected($event.value)"
        >
          <mat-option *ngFor="let c of countryList" [value]="c">
            {{ c.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <!-- Region Field -->
      <mat-form-field class="full-width" color="accent">
        <mat-label>Region*</mat-label>
        <mat-select
          formControlName="region"
          (selectionChange)="onTaxRegionSelected($event.value)"
        >
          <mat-option *ngFor="let r of countryRegions" [value]="r.iso">
            {{ r.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <!-- Tax Type -->
      <mat-form-field appearance="fill">
        <mat-label>Tax Type</mat-label>
        <input matInput placeholder="Tax Type" formControlName="taxType" />
      </mat-form-field>

      <!-- Tax Number -->
      <mat-form-field appearance="fill">
        <mat-label>Tax Number</mat-label>
        <input
          matInput
          placeholder="Tax Number"
          formControlName="taxNumber"
          onkeypress="return (event.charCode >= 48 && event.charCode <= 57) ||
                (event.charCode >= 65 && event.charCode <= 90) ||
                (event.charCode >= 97 && event.charCode <= 122) ||
                event.charCode === 45 ||
                event.charCode === 47"
        />
      </mat-form-field>

      <!-- Tax Percentage -->
      <mat-form-field appearance="fill">
        <mat-label>Tax Percentage</mat-label>
        <input
          matInput
          placeholder="Tax Percentage"
          formControlName="taxPercentage"
          type="number"
          min="0"
          step="0.01"
          (keypress)="allowOnlyDecimalTax($event)"
          oninput="const v = parseFloat(this.value); if (!isNaN(v) && v < 0) this.value = Math.abs(v)"
        />
      </mat-form-field>

      <div class="button-container">
        <button class="save-button" (click)="saveTaxForm()">
          <mat-icon>save</mat-icon>
        </button>
        <button class="close-button" (click)="toggleTaxSidebar()">
          <mat-icon>cancel</mat-icon>
        </button>
      </div>
    </div>
  </div>
</form>
